var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-maps-page"},[_c('div',{staticClass:"va-row"},[_c('div',{staticClass:"flex md12 xs12"},[_c('vuestic-widget',{staticClass:"google-maps-page__widget",attrs:{"headerText":"Google Maps"}},[_c('google-map')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }